import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import React from "react";
import { Row, Col, Space, Tooltip, message, Button, Modal, Image, Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import DriverGroupAdd from "./DriverGroupAdd";
import CompanyStore from "../store/CompanyStore";
import DriverGroupStore from "../store/DriverGroupStore";

class DriverGroupList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.driverGroupStore = new DriverGroupStore();
        this.companyStore = new CompanyStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            loadData: 1,
            companyId: "",
            comp_value: "",
            listDataUpdate: false,
            openAssignForm: false,
            openGroupAddFom: false,
            drgId: "",
            drgIdEdit: "",
        };
    }

    onEdit = async (record) => {
        const Id = record.drgId;

        if (Id) {
            this.context.viewStateStore.setDriverGroupStates({
                companyId: record.companyId,
            });
            await this.setState({ drgId: Id });
            await this.setState({ openGroupAddFom: true });
        }
    };
    async onDelete(record) {
        const response = await this.driverGroupStore.deleteRecord({
            drgId: record.drgId,
        });

        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.setState({ openDeleteModal: false });
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            const setDriverGroupStates =
                this.context.viewStateStore.driverGroupObject;

            await this.setState({ companyId: setDriverGroupStates.companyId });
            await this.driverGroupStore.getDriveGroup({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: setDriverGroupStates.companyId,
            });
            let singleData = await this.companyStore.getCompanyDataById(
                setDriverGroupStates.companyId
            );
            this.setState({ companyVal_Lab: singleData, listDataUpdate: false, loadData: 1 });
        }
    }
    async componentDidMount() {
        // await this.driverGroupStore.loadData({ offset: 0, limit: 50 });
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.handleSearch();
        }
        this.setState({ pageSize: 50 });

        this.columns = [
            {
                // title: "  Device",
                title: this.context.translate("_DRIVER_GROUP_NAME_"),
                dataIndex: "groupName",
                width: "80%",
                render: (value, record) => {
                    return (
                        <Tooltip placement="topLeft" title={value}>
                            <Link
                                style={{ color: "#2563EB", textDecoration: "none" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onEdit(record);
                                }}
                            >
                                {value}
                            </Link>
                        </Tooltip>
                    );
                },
            },
            {
                title: this.context.translate("_ACTION_"),
                dataIndex: "Action",
                key: "Action",
                // fixed: 'right',
                width: "20%",
                render: (_, record) => {
                    return (
                        <>
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_EDIT_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: "19px",
                                            width: "14px",
                                            borderRadius: "0px",
                                            cursor: "pointer",
                                        }}
                                        src={editIcon}
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            await this.onEdit(record);
                                        }}
                                    ></Image>
                                </Tooltip>
                                <Tooltip
                                    title={this.context.translate(
                                        "_FLEET_USER_USERLIST_DELETE_"
                                    )}
                                    placement="bottom"
                                >
                                    <Image
                                        src={require("../assets/images/NewDesign/Delete.png")}
                                        style={{ cursor: "pointer", width: "15px" }}
                                        onClick={() =>
                                            this.setState({
                                                openDeleteModal: true,
                                                deleteData: record,
                                            })
                                        }
                                    ></Image>
                                </Tooltip>
                            </Space>
                        </>
                    );
                },
            },
        ];
    }

    async handleTableChange(pagination, filters, sorter) {
        // console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            pageSize: 50,
            currentPage: 1,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        await this.setState({ companyVal_Lab: singleData });
        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.driverGroupStore.getDriveGroup({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
        });
        await this.setState({ loadData: 1 });
    }
    responseMsg = async (resp) => {

        if (resp.data.success === "S") {
            message.success(resp.data.message);
            this.setState({ openGroupAddFom: false });
            this.setState({ listDataUpdate: true });
        }
        else {
            message.error(resp.data.message);
        }
    };

    closeModal = () => {
        this.setState({ openGroupAddFom: false, driverGroupId: "" });
    };
    refreshList = async () => {
        if (this.state.companyId) {
            this.setState({ loading: true });

            await this.driverGroupStore.getDriveGroup({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
            });
            await this.setState({ loadData: 1 });
            this.setState({ loading: false, currentPage: 1 });
        }
    };
    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    style={{ width: 200 }}
                                />
                            </Space>
                        </Col>
                        <Col
                            span={8}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        alignItems: "center",
                                        cursor: "pointer",
                                        marginInlineEnd: "20px",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>


                            <Button
                                className="addButtonClass"
                                onClick={() =>
                                    this.setState({ openGroupAddFom: true, drgIdEdit: "", drgId: "" })
                                }
                            >
                                <Image
                                    style={{ marginInlineEnd: "5px", width: 13 }}
                                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                ></Image>
                                {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                            </Button>

                        </Col>
                    </Row>
                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.driverGroupStore?.total}
                        columns={this.columns}
                        dataSource={this.driverGroupStore?.driverGroupDrivers}
                        loading={this.driverGroupStore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>

                {this.state.openGroupAddFom && (
                    <Drawer
                        className="uploadExcelDrawer"
                        width={716}
                        closeIcon={false}
                        open={this.state.openGroupAddFom}
                        footer={false}
                        placement={
                            this.context.locale.language === "arabic" ? "left" : "right"
                        }
                        title={
                            <div className="formTitle">
                                {this.context.translate("_DRIVER_GROUP_ADD_")}
                                <p className="formDescription">
                                    {this.context.translate("_DRIVER_GROUP_ADD_DESC_")}
                                </p>
                            </div>
                        }
                        maskClosable={false}
                        onOk={() => this.setState({ openGroupAddFom: false })}
                        onCancel={() =>
                            this.setState({ openGroupAddFom: false, drgId: "", drgIdEdit: "" })
                        }
                    >
                        <div style={{ height: "100%" }}>
                            <DriverGroupAdd
                                drgId={this.state.drgId}
                                companyId={this.state.companyId}
                                response={this.responseMsg}
                                closeModal={this.closeModal}
                            />
                        </div>
                    </Drawer>
                )}


                {this.state.openDeleteModal && (
                    <Modal
                        maskClosable={false}
                        title={
                            <div className="deleteModalTitle">
                                <span>
                                    {" "}
                                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                                </span>
                                <CloseOutlined
                                    style={{ cursor: "pointer", color: "white" }}
                                    onClick={() => this.setState({ openDeleteModal: false })}
                                />
                            </div>
                        }
                        className="deleteModal"
                        description="Are you sure you want to delete this Item? This action cannot be undone."
                        centered
                        open={this.state.openDeleteModal}
                        footer={null}
                        width={400}
                        closable={false}
                    >
                        <div className="deleteModalText">
                            <p>{this.context.translate("_DELETE_STATUS_")}</p>
                        </div>
                        <div className="deleteModalButtons">
                            <Button
                                className="deleteModalCancelButton"
                                onClick={() => this.setState({ openDeleteModal: false })}
                            >
                                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>

                            <Button
                                className="deleteModalOkButton"
                                onClick={() => this.onDelete(this.state.deleteData)}
                            >
                                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                            </Button>
                        </div>
                    </Modal>
                )}
            </>
        );
    }
}
DriverGroupList.contextType = StoreContext;
export default observer(withRouter(DriverGroupList));
